import React, { useEffect, useState } from 'react'
import './dataTableSettings.scss'
import { DataGrid } from '@mui/x-data-grid';
import { settingsColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, getDocs,  deleteDoc, doc, onSnapshot, query, orderBy, where, updateDoc } from "firebase/firestore";
import { db, auth } from '../../firebase'
import ConfirmBox from '../ConfirmBox';
import { deleteUser, getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
// import { getApp } from 'firebase/app'; // Assuming you have firebase app initialized

// const app = getApp();



const DataTable = () => {

  const [ data, setData ] = useState([])

  const [ isLoading, setIsLoading ] = useState(true)
  
  const [open, setOpen] = useState(false);
  
  const [adminId, setAdminId] = useState("");

  // const [adminEmail, setAdminEmail] = useState("")




  const functions = getFunctions();

  // Reference the callable function
  const removeAdminClaim = httpsCallable(functions, 'removeAdminClaim');


    // Reference the callable function
  const addAdminClaimByUid = httpsCallable(functions, 'addAdminClaimByEmailAgain');



  // Assuming you have the target user's UID (e.g., from a user list)
  // const targetUid = "some-user-uid"; 

  // if (auth.currentUser) {
  //   removeAdminClaim({ uid: adminId })
  //     .then((result) => {
  //       console.log(result.data.message);
  //       // Optional: Inform the user and force a token refresh
  //       auth.currentUser.getIdToken(true);
  //     })
  //     .catch((error) => {
  //       console.error("Failed to remove admin claim:", error);
  //       // Handle the error, e.g., display a message to the user
  //     });
  // }




  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }


  useEffect(() => {

//LISTEN REAL TIME

    const unsub = onSnapshot(collection(db, "admins"), (snapShot) => {
      let list = [];
      snapShot.docs.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data()})
      })
      setData(list)
      setIsLoading(false)
    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

//END LISTEN REAL TIME    

  },[])

  console.log(data)




  function openDelete(id) {
        setOpen(true);
        setAdminId(id);

  }
  
    console.log(data)


  
  // const handleDeleteInfo = async() => {
  
  //     await deleteDoc(doc(db, "admins", adminId));
        
  //       setData(data.filter((item) => item.id !== adminId))

  //       // handleDeleteUser()
  
  
  // }



  // const handleStatusChange = async() => {

  //       const adminRef = doc(db, "admins", adminId);
        
  //           await updateDoc(adminRef, {
        
  //           status: data.status === "active" ? 'inactive' : 'active', 
        
  //        })
        
  //         setOpen(false) 
  // }


  // const handleDelete = () => {

  //    if(data.status === "active"){


  //            removeAdminClaim({ uid: adminId })

  //           .then((result) => {

  //             handleStatusChange()

  //             console.log(result.data.message);

  //              alert(result.data.message)
  //             // Optional: Inform the user and force a token refresh
  //             auth.currentUser.getIdToken(true);
              
  //             setOpen(false)

  //           })

  //           .catch((error) => {

  //             console.error("Failed to remove admin claim:", error);
  //             // Handle the error, e.g., display a message to the user
  //           });


          
  //       }else{


  //            addAdminClaimByUid({ uid: adminId })

  //           .then((result) => {

  //             handleStatusChange()

  //             console.log(result.data.message);

  //              alert(result.data.message)
  //             // Optional: Inform the user and force a token refresh
  //             auth.currentUser.getIdToken(true);
              
  //             setOpen(false)

  //           })

  //           .catch((error) => {

  //             console.error("Failed to remove admin claim:", error);
  //             // Handle the error, e.g., display a message to the user
  //           });



  //       }


  //     // if (auth.currentUser) {

       

   
  //     // }

  // }



  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 230, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                       <Link to={`/settings/${params.row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>

                         {/* <Link
                          onClick={() => openDelete(params.row.id)}
                          to={"#"}
                          className="deletebutton"
                        >
                            Delete
                        </Link> */}
                       
                        {/* <div className='deletebutton' onClick={() => handleDelete(params.row.id)}>Delete</div> */}
                    </div>
                )
            }
    }
      
  ]  

  return (

    <>

       <div className="datatable">
      <div className='datatableTitle'>
        All Chillaxia Admins
        <div style={{display: 'flex', flexDirection:'row', gap:"10px"}}>
            <Link to="/settings/new"  style={{textDecoration:"none"}} >
              <div className='link'>
                Add New Admin
              </div>
            </Link>

        </div>
      
      </div>
      {isLoading 
      ? <Spinner/>
      :<DataGrid
          className="userTableGrid"
          rows={data}
          columns={settingsColumns.concat(actionColumn)}
          pageSize={5}
          rowsPerPageOptions={[5]}
          checkboxSelection
        />
      }
    </div>
    
    
    
    {/* <ConfirmBox
        open={open}
        closeDialog={() => setOpen(false)}
        // title={deleteData?.name}
        deleteFunction={handleDelete}
    /> */}

    </>

   
  )
}

export default DataTable